export default __webpack_public_path__ + "static/media/esrp5.963570be.svg";